<agr-form-dialog [formGroup]="formGroup" [data]="data" (confirm)="confirm()" (cancel)="cancel()" class="flex--gutter-container">
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'year' | translate }}</mat-label>
      <mat-select formControlName="calendarYear" placeholder="{{ 'year' | translate }}" data-test="edit-fertilizer-type">
        @for (option of years; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'cropAid' | translate }}</mat-label>
      <input
        type="text"
        matInput
        placeholder="{{ 'cropAid' | translate }}"
        formControlName="cropAidId"
        data-test="edit-crop-aid-id"
        [matAutocomplete]="cropAidAutocomplete"
      />
      <mat-autocomplete #cropAidAutocomplete="matAutocomplete" [displayWith]="displayCropAid()">
        @for (option of filteredCropAids$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-crop-aid-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'phosphateLegalWorkingCoefficient' | translate }}</mat-label>
      <input
        type="number"
        matInput
        placeholder="{{ 'phosphateLegalWorkingCoefficient' | translate }}"
        formControlName="phosphateWorkingCoefficient"
        data-test="edit-phosphate-working-coefficient"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
